import { Entity } from './entity';
import { Transaction } from './transaction';
import { Study } from './study';
import { Collapsible } from '../interfaces';
import { MethodEvaluationEnum } from './enums';
import { TestedParty } from './tested-party';

export class Pba implements Collapsible {
  pbaId: number;
  name: string;
  description?: string;
  exclude = false;
  method: MethodEvaluationEnum;
  primaryLegalEntity: Entity;
  study: Study;
  collapsed: boolean;
  transactions: Transaction[]; // used for displaying controlled transactions in tba list
  testedParty?: TestedParty;
  pbaEvaluationMethod?: { name: string };
}
